<template>
  <div class="wrapper" v-if="reFresh">
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)"
    ></video-player>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
    // 关闭时保存位置
    reFresh (val) {
      if (!val) {
        let data = {
          record_class_id: this.row.id,
          second: this.lookDuration
        }
        this.$axios.post('/app/correlation_record_class_watch_log/setTime', data).then(res => {
          console.log(res)
        })
      }
    },
  },
  mounted() {
    this.reFresh = true
  },
  data() {
    //这里存放数据
    return {
      reFresh: false, // 组件重置与销毁
      lookDuration: "", // 视频观看位置
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
        playtimes: 0, // 视频观看的起点
      },
    };
  },
  //方法集合
  methods: {
    // 是否重置组件
    reFreshControl(isRefresh) {
      this.reFresh = isRefresh
      if(isRefresh) {
        this.$nextTick(() => {
          this.playerOptions.sources[0].src = this.path + this.row.video
          console.log(this.row.seconds)
          this.playerOptions.posterc = this.row.image
          this.playerReadied(this.$refs.videoPlayer.player)
        })
      }
    },
    //监听播放
    onPlayerPlay(player) {
      // this.$refs.videoPlayer.player.play();
    },
    //监听暂停
    onPlayerPause(player) {
      // this.$refs.videoPlayer.player.pause();
    },
    //监听播放状态改变
    playerStateChanged(player) {
      if (Math.floor(player.timeupdate)) {
        this.lookDuration = Math.floor(player.timeupdate);
      }
    },
    //监听媒体是否已到达结尾，播放完
    onPlayerEnded(player) {
      // 结束时销毁组件
      this.reFresh = false;
      this.$emit("cancelWatch");
    },
    //DOM元素上的readyState更改导致播放停止。
    onPlayerWaiting(player) {
      // console.log(player);
    },
    //媒体不再被禁止播放，并且已开始播放。
    onPlayerPlaying(player) {
      // console.log(player);
    },
    //当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata(player) {
      // console.log(player);
    },
    //当前播放位置发生变化时触发。
    onPlayerTimeupdate(player) {
      // console.log(player);
    },
    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      player.currentTime(this.row.seconds)
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 70%;
  margin: 0 auto;
  color: #fff;
}
/deep/.ivu-modal-content {
  background-color: rgba(0, 0, 0, 0.7);
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
